import styled from "styled-components";

export const Container = styled.div`
  width: 320px;
  height: 673px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: #ffffff;

  position: relative;
  padding: 0 23px;
  border-radius: 6px;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);

  cursor: pointer;

  &:hover {
    transform: scaleY(1.1);
    box-shadow: 0 6px 20px #69adff;
    background-image: linear-gradient(
      40deg,
      rgba(39, 117, 225, 0.94) 0%,
      rgba(0, 198, 255, 0.94) 100%
    );

    h2,
    p,
    span {
      color: #ffffff;
    }

    button {
      background-color: #0b98f6;
      color: #ffffff;
      box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3);
    }
  }
`;

export const BestSeller = styled.div`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 105px;
  height: 105px;
  overflow: hidden;
  z-index: 9;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    width: 5px;
    height: 5px;
    background-color: #0b98f6;
  }

  &::after {
    position: absolute;
    right: 0;
    bottom: 0;
    content: "";
    width: 5px;
    height: 5px;
    background-color: #0b98f6;
  }

  span {
    width: calc(100% + 54px);
    height: 36px;

    position: absolute;
    bottom: 0;
    right: 0;
    transform: rotate(45deg);
    transform-origin: right bottom;
    z-index: 9;
    padding-left: 11px;
    background-color: #68dcfe;

    font-weight: 700;
    font-size: 14px;
    text-align: center;
    line-height: 36px;
    text-transform: uppercase;
    font-family: "Montserrat", sans-serif;
    color: #ffffff;
  }
`;

export const LogoLingo = styled.img`
  width: 45px;
  height: 45px;
  margin-top: 90px;
  margin-bottom: 30px;
`;

export const NamePlan = styled.h2`
  font-weight: 700 !important;
  font-size: 25px !important;
  line-height: 31px !important;
  font-family: "Montserrat", sans-serif;
  color: #292b2c;

`;

export const WrapperIconsLanguages = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;

  margin-top: 10px;
`;

export const DescriptionPlans = styled.div`
  opacity: 0.7;
  margin: 26px 0 19px 0;

  p {
    font-weight: 650;
    font-size: 15px;
    line-height: 25px;
    text-align: center;
    font-family: "Open Sans", sans-serif;
    color: "#292B2C";
  }
`;

export const DiscountPercent = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 0.7;
  padding: 10px;
  margin: 5px 0 2px;
  background-color: rgb(11, 161, 6);

  font-weight: 600;
  font-size: 15px;
  border-radius: 8px;
  font-family: "Open Sans", sans-serif;
  color: #ffffff;
`;

export const PriceBase = styled.p`
  display: flex;
  opacity: 0.7;
  align-items: center;
  margin-bottom: 10px;

  color: #3da8fe;
  font-size: 15px;
  font-weight: 600;
  text-decoration: line-through;
  font-family: "Open Sans", sans-serif;
`;

export const PricePlans = styled.p`
  display: flex;
  align-items: center;

  font-size: 56px;
  font-weight: 700;
  font-family: "Montserrat", sans-serif;
  color: #292b2c;

  span {
    font-size: 15px;
  }
`;

export const Month = styled.p`
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  opacity: 0.7;
  font-weight: 600;
  font-size: 15px;
  text-align: center;
  line-height: 15px;
  font-family: "Open Sans", sans-serif;
  color: #292b2c;

  margin-top: 5px;
  margin-bottom: ${({ discount }) => (discount === "true" ? 3 : 7.5)}px;

  span {
    font-size: 10px;
    font-weight: 700;
  }
`;

export const ButtonSelect = styled.a`
  width: 70%;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  color: #ffffff !important;
  background-color: #2775ff;

  margin: 10px;
  border-radius: 30px;
  padding: 16px 33px;
  box-shadow: 0 5px 16px rgba(39, 117, 225, 0.5);

  &:hover {
    transition: 0.3s;
    color: #2775ff !important;
    background-color: #ffffff !important;
  }
`;
